<template>
  <LpuTypeModal
    :value="isDialogOpened"
    @input="handleCloseModal"
  >
    <template #footer>
      <BtnApplyFilters
        :active="isDialogOpened"
        class="pa-2 elevation-8"
        @click:submit="applySelectedLpuType"
        @click:close="closeDialog"
      />
    </template>
  </LpuTypeModal>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import { dispatchCustomEventGlobally } from 'www/utils'
import I18NextVue from 'i18next'
import useChipsStore from 'www/vue_components/common/TheFilters/lpu/stores/useChipsStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import updateLpuListPage from 'www/vue_components/common/TheFilters/lpu/functions/updateLpuListPage'
import BtnApplyFilters from 'www/vue_components/common/TheFilters/lpu/components/BtnApplyFilters/BtnApplyFilters.vue'
import LpuTypeModal from 'www/vue_components/common/TheFilters/lpu/components/LpuTypeFilters/components/LpuTypeModal.vue'
import { EVENTS as SNACKBAR_EVENTS } from 'www/vue_components/common/core/SnackbarNotification/constants'

const chipsStore = useChipsStore()
const filtersStore = useFiltersStore()

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const { isDialogOpened, openDialog, closeDialog } = useDialogManager('LpuType')

watch(
  () => filtersStore.filters.lpuType,
  () => {
    chipsStore.updateLpuTypeChip({
      name: filtersStore.filters.lpuType?.name || 'Тип клиники',
      isActive: !!filtersStore.filters.lpuType,
      dropdown: !filtersStore.filters.lpuType,
      truncate: true,
      isVisible: true,
      onClick: openDialog,
      onReset: async () => {
        filtersStore.updateFilters({ lpuType: undefined })

        await updateLpuListPage()

        dispatchCustomEventGlobally(SNACKBAR_EVENTS.open, {
          upper: true,
          message: t('Фильтр сброшен', options.value),
        })
      },
    })
  },
  { immediate: true },
)

function applySelectedLpuType() {
  closeDialog()
  filtersStore.applyUnsavedFilters()
  updateLpuListPage()
}

function handleCloseModal() {
  closeDialog()
  filtersStore.resetUnsavedFilters()
}
</script>
